import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Route, Redirect, withRouter} from 'react-router';
import {USER_LANG} from 'utils/locale';


const PrivateRoute = ({token, ...rest}) => {
    if (token) {
        return (
            <Route {...rest} />
        );
    }
    return (
        <Redirect to={`/${USER_LANG}/production/auth`} />
    );
};
PrivateRoute.propTypes = {
    token: PropTypes.string,
};
PrivateRoute.defaultProps = {
    token: null,
};


const mapStateToProps = state => ({
    token: state.workers.token,
});


export default withRouter(connect(
    mapStateToProps,
)(PrivateRoute));



// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js